export default __webpack_public_path__ + "static/media/uploader-roche-3.2b1e33cc.png";